// extracted by mini-css-extract-plugin
export var banner = "_jk-0";
export var closeButton = "_jk-2";
export var greenCheckmark = "_jk-3";
export var hereLink = "_jk-4";
export var titleIcon = "_jk-1";